import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { firstValueFrom } from 'rxjs';
import { MandateModel } from './mandate.model';
import { ApiResponse } from '../../../models/base';

const LIST_ENDPOINT = '/mandates';
const PDF_ENDPOINT = '/mandatespdf';

@Injectable({
  providedIn: 'root',
})
export class MandateService {
  private readonly http = inject(HttpClient);

  async pdf(uid: string): Promise<Blob> {
    const response = await firstValueFrom(
      this.http.get(environment.apiUrl + `${PDF_ENDPOINT}/${uid}`, {
        responseType: 'blob',
      })
    );

    return new Blob([response], { type: 'application/pdf' });
  }

  async addData(mandate: MandateModel): Promise<MandateModel> {
    const response = await firstValueFrom(
      this.http.post<ApiResponse<MandateModel>>(environment.apiUrl + LIST_ENDPOINT, mandate)
    );

    return response.data;
  }

  async deleteData(uid: string): Promise<string> {
    const response = await firstValueFrom(
      this.http.delete<{ message: string }>(environment.apiUrl + `${LIST_ENDPOINT}/${uid}`)
    );

    return response.message;
  }

  async editData(uid: string, mandate: MandateModel): Promise<MandateModel> {
    const response = await firstValueFrom(
      this.http.put<ApiResponse<MandateModel>>(
        environment.apiUrl + `${LIST_ENDPOINT}/${uid}`,
        mandate
      )
    );

    return response.data;
  }

  async loadData(uid: string): Promise<MandateModel> {
    const response = await firstValueFrom(
      this.http.get<ApiResponse<MandateModel>>(environment.apiUrl + `${LIST_ENDPOINT}/${uid}`)
    );

    return response.data;
  }

  async getList(): Promise<MandateModel[]> {
    const response = await firstValueFrom(
      this.http.get<ApiResponse<MandateModel[]>>(environment.apiUrl + LIST_ENDPOINT)
    );

    return response.data;
  }
}